export default "__VITE_ASSET__BIKyfWPU__"